exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create/universe_lite/Security/security_universe/security.styles.scss
// module id = 727
// module chunks = 0